import request from "superagent";
import { getTabToken } from "common/MetaActions";
import config from "config/config";
import { useRootStore } from "store";
import { Attachment } from "models/dashboard/dashboard";
import { MessageType } from "store/slices/inboxSlice";

type QueryParams = { skip: number; limit: number; searchCriteria?: string };

export class InboxAPI {
  static deleteThreadMessage = async ({
    customerId,
    messageId,
    threadId,
    messageType,
  }) => {
    const response = await request
      .delete(config.api.message.del({ customerId, messageId, threadId }))
      .set("Authorization", "Bearer " + getTabToken())
      .send({
        Type: messageType,
      });

    return response;
  };

  static fetchThread = async (customerId: string, threadId: string) => {
    const response = await request
      .get(
        config.api.customer.thread.get +
          customerId +
          "/thread/" +
          encodeURIComponent(threadId),
      )
      .set("Accept", "application/json")
      .set("Authorization", "Bearer " + getTabToken());

    return response.body;
  };

  static fetchThreads = async (
    customerId: string,
    getAllThreads = false,
    skip = 0,
    searchTerms = "",
  ) => {
    let queryParam: QueryParams = {
      skip: skip,
      limit: config.defaults.pageSize,
    };
    if (searchTerms !== "") {
      queryParam = { ...queryParam, searchCriteria: searchTerms };
    }

    const response = await request
      .get(
        config.api.customer.threads.get +
          customerId +
          "/threads" +
          (getAllThreads ? "/All" : ""),
      )
      .set("Accept", "application/json")
      .set("Authorization", "Bearer " + getTabToken())
      .query(queryParam);

    return response.body;
  };

  static fetchMoreThreads = async (
    customerId: string,
    getAllThreads: boolean,
    skip: number,
    searchTerms?: string,
  ) => {
    let queryParam: QueryParams = {
      skip: skip,
      limit: config.defaults.pageSize,
    };
    if (searchTerms !== "") {
      queryParam = { ...queryParam, searchCriteria: searchTerms };
    }

    const response = await request
      .get(
        config.api.customer.threads.get +
          customerId +
          "/threads" +
          (getAllThreads ? "/All" : ""),
      )
      .set("Accept", "application/json")
      .set("Authorization", "Bearer " + getTabToken())
      .query(queryParam);

    return response.body;
  };

  static setThreadStatus = async (threadId: string, action: string) => {
    const workingCustomerId = useRootStore.getState().global.workingCustomerId;

    const response = await request
      .put(config.api.customer.thread.put(workingCustomerId, threadId))
      .set("Accept", "application/json")
      .set("Authorization", "Bearer " + getTabToken())
      .send({
        Action: action,
      });

    return response;
  };
  static fetchSentMessages = async (customerId: string) => {
    const response = await request
      .get(config.api.message.sentMessage(customerId))
      .set("Accept", "application/json")
      .set("Authorization", "Bearer " + getTabToken());

    return response.body;
  };
  static sendMessage = async (
    fromUserId: string,
    body: string,
    title: string,
    threadId: string | null,
    subscribers: string[],
    customerId: string,
    attachments: Attachment[],
    type = MessageType.Normal,
    reportStart = "",
    reportEnd = "",
  ) => {
    const response = await request
      .post(config.api.message.post)
      .set("Accept", "application/json")
      .set("Authorization", "Bearer " + getTabToken())
      .send({
        From: fromUserId,
        Body: body,
        Title: title,
        ThreadId: threadId,
        Subscribers: subscribers,
        CustomerId: customerId,
        Attachments: attachments,
        Type: type,
        ReportStartPeriod: reportStart,
        ReportEndPeriod: reportEnd,
      });

    return response.body;
  };
}
